import { render, staticRenderFns } from "./VesselCourseDanger.vue?vue&type=template&id=1ae184da&"
import script from "./VesselCourseDanger.vue?vue&type=script&lang=js&"
export * from "./VesselCourseDanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports